import Home from './downloads-page';

export default {
  Home
};
